import { Alert, Card, Col, Divider, Input, Radio, Row, Slider, Space, Switch } from 'antd';
import React, {useState, useReducer, useRef, useEffect} from 'react';
import { convertUtils } from './utils';
import Resizer from 'react-image-file-resizer';
import Title from '../../components/Title';
import './index.css';

const fileFilter = /^(?:image\/bmp|image\/cis-cod|image\/gif|image\/ief|image\/jpeg|image\/jpeg|image\/jpeg|image\/pipeg|image\/png|image\/svg\+xml|image\/tiff|image\/x-cmu-raster|image\/x-cmx|image\/x-icon|image\/x-portable-anymap|image\/x-portable-bitmap|image\/x-portable-graymap|image\/x-portable-pixmap|image\/x-rgb|image\/x-xbitmap|image\/x-xpixmap|image\/x-xwindowdump)$/i;
const sizeSelect = ['1-54-bw', '2-13-bw', '2-6-bw', '2-7-bw', '2-9-bw', '4-2-bw', '5-83-bw', '7-5-bw'];

export default () => {
  const [uploadImageUrl, setUploadImageUrl] = useState('');
  const [canvasImg, setCanvasImg] = useState('');
  const [uploadError, setUploadError] = useState(false);
  const [file, setFile] = useState(null);
  const [deg, setDeg] = useState(0);
  const [threshold, setThreshold] = useState(33);
  const [invert, setInvert] = useState(false);
  const [mirror, setMirror] = useState(false);//'horizontal'//vertical
  const [isCustom, setIsCustom] = useState(false);
  const canvasRef = useRef (null);
  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case 'success':
        return {...state, result: action.payload}
      case 'failed':
        return {...state, error: action.payload}
      default:
        return state;
    }
  }, {result: '', error: ''});

  useEffect(() => {
    convertUtils(canvasImg, canvasRef.current, dispatch, {threshold, invert, mirror});
  }, [canvasImg, threshold, invert, mirror]);

  useEffect(() => {
    if (file) {
      Resizer.imageFileResizer(file, 5000, 5000, 'BMP', 100, deg, uri => setCanvasImg(uri), 'base64')
    }
  }, [file, deg]);

  function handleFileChange(e) {
    const file = e.currentTarget.files[0];

    if (!file) return;

    if (file.size > 1080054) {//限制尺寸1.02M
      setUploadError(`Error, ${file.name} is too big, please reselect the image.`);
      return;
    };

    console.log(file);
    if (file && !fileFilter.test(file.type)) {
      setUploadError(`Error, ${file.name} format not supported, please reselect the image.`);
      return;
    }
    const fileUrl = window.URL.createObjectURL(file);
    setUploadImageUrl(fileUrl);
    setFile(file);
    // Resizer.imageFileResizer(file, 5000, 5000, 'BMP', 100, 180, uri => setCanvasImg(uri), 'base64');
  }

  function handleAlertAfterClose() {
    setUploadError(false);
  }

  function handleDegChange(value) {
    setDeg(value);
  }

  function handleThresholdChange(value) {
    setThreshold(value);
  }

  function handleInvertColor(checked, e) {
    setInvert(checked);
  }

  function handleMirror(checked, e) {
    if (checked) {
      setMirror('horizontal');
    } else {
      setMirror('vertical');
    }
  }

  function handleResultChange(e) {
    dispatch({type: 'success', payload: e.target.value});
  }

  function handleModeTransform() {
    setIsCustom(c => !c);
    //init
    setMirror(false);
    setDeg(0);
  }

  function handleDifferentSize(e) {
    if (!sizeSelect.includes(e.target.value)) return;
    //threshold, invert, mirror,file, deg
    setThreshold(33);
    setInvert(false);

    switch (e.target.value) {
      case '1-54-bw':
      case '2-13-bw':
      case '2-6-bw':
      case '2-7-bw':
      case '2-9-bw':
        setMirror('vertical');
        setDeg(270);
      break;
      default:
        setMirror(false);
        setDeg(0);
      break;
    }
  }

  return(
    <div className='image-to-hex'>
      <Title title='E-ink Bitmap Array'/>
      <Space direction='vertical' size='middle'>
        {uploadError && <Alert
          banner
          closable
          description= {uploadError}
          type='error'
          afterClose={handleAlertAfterClose}
          className='image-to-hex-alert'
        />}
        <div className='to-hex-upload'>
          <Input type='file' size='large' onChange={handleFileChange} bordered={false}/>
        </div>
        <div className='mode-selection'>
          <Divider orientation='left'>{!isCustom ? 'Presets' : 'Custom'}</Divider>
          {!isCustom && <Radio.Group onChange={handleDifferentSize} className='mode presets' size='middle'>
            <Radio.Button value='1-54-bw'>1.54 White And Black</Radio.Button>
            <Radio.Button value='2-13-bw'>2.13 White And Black</Radio.Button>
            <Radio.Button value='2-6-bw'>2.6 White And Black</Radio.Button>
            <Radio.Button value='2-7-bw'>2.7 White And Black</Radio.Button>
            <Radio.Button value='2-9-bw'>2.9 White And Black</Radio.Button>
            <Radio.Button value='4-2-bw'>4.2 White And Black</Radio.Button>
            <Radio.Button value='5-83-bw'>5.83 White And Black</Radio.Button>
            <Radio.Button value='7-5-bw'>7.5 White And Black</Radio.Button>
          </Radio.Group>}
          <UserCustom 
            file={file}
            isCustom={isCustom}
            setMirror={setMirror}
            handleMirror={handleMirror}
            handleInvertColor={handleInvertColor}
            handleDegChange={handleDegChange}
            handleThresholdChange={handleThresholdChange}
          />
          <Divider />
          <div className='mode custom'>
            {!isCustom ? <p>Not meeting demand ?</p> : <p>I know what I need</p>}
            <span className='user-custom' onClick={handleModeTransform}>{isCustom ? 'By Presets' : 'By Custom'}</span>
          </div>
        </div>
        {uploadImageUrl && <div className='upload-image-result' >
          <Row gutter={[16, 8]} align='top'>
            <Col>
              <Row align='middle' gutter={[16, 8]}>
                <Col>
                  <Card><img src={uploadImageUrl}/></Card>
                </Col>
                <Col>
                  <p className='arrow'>{'> > >'}</p>
                </Col>
              </Row>
            </Col>
            <Col>
              <Card bordered={false} className='canvas'><canvas ref={canvasRef}/></Card>
            </Col>
          </Row>
          <Card className='show-data-result'>
            <Input.TextArea showCount value={state.result} onChange={handleResultChange}/>
          </Card>
        </div>}
      </Space>
    </div>
  );
}

function UserCustom({file, isCustom, setMirror, handleMirror, handleInvertColor, handleDegChange, handleThresholdChange}) {
  const [mirrorSwitch, setMirrorSwitch] = useState(false);

  function handleMirrorSwitch(checked, e) {
    setMirrorSwitch(checked);

    if (checked) {
      setMirror('vertical');
    } else {
      setMirror(false);
    }
  }
  return(
    <>
      {isCustom && <>
        {file &&<div className='to-hex-mirror'>
          Mirror ?
          <br />
          <Switch checkedChildren="open" unCheckedChildren="close" onClick={handleMirrorSwitch} id='mirror'/>
          <br />
          {mirrorSwitch && <>
            Mirror axis:
            <br/>
            <Switch checkedChildren="horizontal" unCheckedChildren="vertical" onClick={handleMirror}/>
          </>}
        </div>}
        <div className='to-hex-invert'>
          Invert color:
          <br />
          <Switch  onClick={handleInvertColor}/>
        </div>
        <div className='to-hex-deg'>
          Rotation angle: 
          <br/>
          <Slider defaultValue={0}  step={90} max={360} onChange={handleDegChange}/>
        </div>
        <div className='to-hex-threshold'>
          Color extraction threshold:
          <Slider defaultValue={33} max={255} onChange={handleThresholdChange}/>
        </div>
      </>}
    </>
  );
}